import script from "./BmsBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BmsBoard.vue?vue&type=script&setup=true&lang=ts"

import "./BmsBoard.vue?vue&type=style&index=0&id=85e83314&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-85e83314"]])

export default __exports__